// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"dbd0055f","156":"2523f6f3","222":"e5656fd5","506":"12326326","694":"e8b9841f","942":"6d05d56b"}[chunkId] + ".css";
};